module.exports = __webpack_public_path__ + "media/images/amenities_icons/pool_table-4a086e0e3c8d2c76b94d4fbccec45134.svg";